import { defineAction } from '~/prix'
import { z } from 'zod'
import insightExportAction from './buildInsightsExport.action.json' assert { type: 'json' }
import { ALERT_PRESET_FILTER_OPTIONS } from '../alertTypes.constants'

const normalizeStringArrayInput = (value: unknown) => {
  if (value == null) {
    return undefined
  }

  const values = Array.isArray(value) ? value : [value]

  const normalizedValues = values
    .flatMap(currentValue => String(currentValue).split(','))
    .map(currentValue => currentValue.trim())
    .filter(Boolean)

  return normalizedValues.length > 0 ? normalizedValues : undefined
}

const stringArrayInputZod = z.preprocess(
  normalizeStringArrayInput,
  z.array(z.string().trim().min(1)).optional(),
)

const uuidArrayInputZod = z.preprocess(
  normalizeStringArrayInput,
  z.array(z.string().uuid()).optional(),
)

const insightExportDefinition = defineAction({
  ...insightExportAction,
  input: z.object({
    insightIds: uuidArrayInputZod,
    search: z.string().trim().optional(),
    delimitation: z.string().trim().optional(),
    variableKeys: stringArrayInputZod,
    variablePresetKeys: stringArrayInputZod,
    alertType: stringArrayInputZod,
    alertPreset: z.enum(ALERT_PRESET_FILTER_OPTIONS).optional(),
    sortBy: z
      .enum(['relevance', 'description', 'state', 'alertBadge', 'alertType', 'variable'])
      .optional(),
    sortOrder: z.enum(['asc', 'desc']).optional(),
    format: z.enum(['xlsx', 'csv']),
  }),
  output: z.object({}).passthrough(),
})

export default insightExportDefinition
